import { useEffect, useState } from 'react';

import { H3 } from '@common/headline';
import ArticleTile from '@components/Resources/Home/ArticleTile';
import { RecentArticleEdgeType } from '@nextTypes/guides';
import { getRecentArticles } from '@nextUtils/guidesUtils';

type Props = {
  posts: RecentArticleEdgeType[];
};

const SameCategoryArticles = ({ posts }: Props): JSX.Element | null => {
  const [randomNumber, setRandomNumber] = useState(0);

  useEffect(() => {
    setRandomNumber(Math.random());
  }, []);

  if (posts.length === 0) {
    return null;
  }

  // Pick up to 3 random posts to display
  const randomPosts = posts.sort(() => 0.5 - randomNumber).slice(0, 3);

  const randomArticleTiles = getRecentArticles({
    edges: randomPosts,
  }).map(article => (
    <ArticleTile
      imageUrl={article.featuredImageUrl}
      category={article.category}
      date={article.date}
      href={article.href}
      key={article.title}
      shouldDisplayCategory={false}
      title={article.title}
    />
  ));

  return (
    <>
      <div className="mt-5">
        <H3>You might also like</H3>
      </div>
      <div className="mb-20 flex flex-wrap justify-between">
        {randomArticleTiles}
      </div>
    </>
  );
};

export default SameCategoryArticles;
